import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { styled } from '@styledComponents';
import { TOP_BANNER_HEIGHT } from '@layout';
import { Button } from '@components/Button';
import { Text } from '@components/typography';
import { ButtonTextStyles } from '@components/typography/interVariants';
import { TOP_BAR_DEFAULT_HEIGHT_DESKTOP } from 'src/layout/components/Header/Header.styles';
import { themeColor, themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';

const SEARCH_BAR_MAX_WIDTH = 848;
const TEXT_MAX_WIDTH = 345;

export const StyledSection = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  padding-top: calc(${TOP_BANNER_HEIGHT}px + ${TOP_BAR_DEFAULT_HEIGHT_DESKTOP}px);
`;

export const SearchWrapper = styled(Flex)`
  flex: 1;
  width: 100%;
  text-align: center;
  flex-direction: column;
  max-width: ${SEARCH_BAR_MAX_WIDTH}px;
`;

export const StyledHeading = styled(Text)`
  ${themeMediaQuery('below_sm')} {
    ${themeVariant('hed40')};
  }
`;

export const StyledText = styled(Text)`
  ${themeMediaQuery('below_sm')} {
    max-width: ${TEXT_MAX_WIDTH}px;
    margin-left: auto;
    margin-right: auto;
    ${themeVariant('featureHed17')};
  }
`;

export const ResponseWrapper = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const CountText = styled(Text)<{ error: Boolean }>`
  color: ${({ error }) => (error ? themeColor('red5') : themeColor('mono1'))};
  align-self: flex-start;
`;

export const ResultList = styled(Box)`
  width: 100%;
  max-width: 1225px;
  display: flex;
  flex-direction: column;
  ${themeMediaQuery('md')} {
    padding-left: ${themeSpace(9)};
    padding-right: ${themeSpace(9)};
  }
`;

export const NoDataMsg = styled(Text)`
  width: 100%;
  color: ${themeColor('mono1')};
  padding-top: ${themeSpace(5)};
  padding-bottom: ${themeSpace(5)};
  line-height: 45px;
`;

export const BoulderContainer = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  ${themeMediaQuery('below_sm')} {
    position: fixed;
    bottom: 0;
  }
`;

export const SuggestionsContainer = styled(Box)`
  max-width: 625px;
  padding-right: 25px;
`;

export const NoDataDetailText = styled(Text)`
  margin-bottom: 25px;
  font-size: 17px;
`;

export const ShowAllButton = styled(Button)`
  ${ButtonTextStyles};
  height: 40px;
  padding: 0 ${themeSpace(5)};
  color: ${themeColor('mono12')};
  background-color: transparent;
  border: 2px solid ${themeColor('mono12')};
  &:hover {
    background-color: transparent;
    border: 2px solid ${themeColor('mono1')};
  }
`;
